import Link from 'next/link';
import { Box, Divider, SystemIcon, Typography } from '@wishket/design-system';

import ArticleAuthor from '../Article/ArticleAuthor';
import ArticleInfo from '../Article/ArticleInfo';

import { formatViewCount } from '@/shared/utils';

interface HeaderProps {
  categoryName: string;
  categoryHref: string;
  title: string;
  authorName: string;
  authorHref: string;
  authorImgUrl?: string;
  time: number;
  date?: string;
  isPopular?: boolean;
  viewCount: number;
}

const ArticleDetailHeader = ({
  categoryName,
  categoryHref,
  title,
  authorName,
  authorHref,
  authorImgUrl,
  time,
  date,
  isPopular,
  viewCount,
}: HeaderProps) => {
  return (
    <header className="box-border flex w-full flex-col gap-4 desktop:gap-5">
      <Box className="flex flex-col gap-2">
        <Link href={categoryHref} data-testid="category-link">
          <Typography
            variant="body2"
            className="font-medium text-w-gray-600 hover:underline"
          >
            {categoryName}
          </Typography>
        </Link>
        <h1 className="font-normal tracking-[0.48px] text-w-gray-900 typo-title3 desktop:typo-title2">
          {title}
        </h1>
      </Box>
      <Box className="flex items-end justify-between desktop:items-center">
        <Box className="flex flex-col items-start gap-3 desktop:flex-row desktop:items-center desktop:gap-2">
          <Box className="flex w-full items-center gap-2 desktop:w-fit">
            <ArticleAuthor
              name={authorName}
              href={authorHref}
              imgUrl={authorImgUrl}
              isDarkText
            />
            <Divider isVertical className="hidden h-3.5 desktop:flex" />
          </Box>
          <ArticleInfo time={time} date={date} isPopular={isPopular} />
        </Box>
        <Box className="flex items-center gap-1.5">
          <SystemIcon name="medium_eye" className=" text-w-gray-500" />
          <Typography variant="body2" className="text-w-gray-500">
            {formatViewCount(viewCount)}
          </Typography>
        </Box>
      </Box>
    </header>
  );
};

export default ArticleDetailHeader;
